import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ReflectionInfoFragmentDoc } from '../../fragments/__generated__/ReflectionInfo.generated';
import { ProductBaseInfoFragmentDoc } from '../../fragments/__generated__/Product.generated';
import { ProductPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductPriceRange.generated';
import { ProductVariantDetailsFragmentDoc } from '../../fragments/__generated__/ProductVariant.generated';
import { SupplyProductFragmentDoc } from '../../fragments/__generated__/SupplyProduct.generated';
import { RewardProgramFragmentDoc } from '../../fragments/__generated__/RewardProgram.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductReflectionsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  categories?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  end?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderBy: Array<Types.ProductSiteSpecificsOrder> | Types.ProductSiteSpecificsOrder;
  q?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoriesSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productCollectionsSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sale?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  withSale?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  promoCode?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
  attributeData?: Types.InputMaybe<Types.Scalars['String']['input']>;
  idIn?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  isWholesale?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  includeVariants?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  cartType: Types.CartTypeEnum;
  isSupply?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  cartToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productIsMainRelated?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  withSimilar?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ProductReflectionsQuery = { specifics: { totalCount: number | null, pageInfo: { endCursor: string | null, hasNextPage: boolean }, edges: Array<{ node: { id: string, pk: number, name: string, shortName: string, slug: string, videoUrl: string | null, categories: Array<{ id: string, pk: number, name: string, level: number, slug: string }>, product: { wholesaleVariantsCount: number, attrs?: Array<string>, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, thumbnail: { lg: string | null, sm: string | null }, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, variants?: Array<{ stockQuantity: number, stockStatus: Types.OutOfStockStatusEnum | null, outOfStockStatus: Types.OutOfStockStatusEnum, cartQuantity: number, cartLines: Array<number>, thumbnailUrl: string | null, isSupply: boolean, itemData: any | null, id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, wholesaleDescription: string, isCustomizable: boolean, wholesalePrice: { currency: string, undiscount: number, discount: number }, supplyProducts: Array<{ id: string, pk: number, name: string, sortOrder: number, product: { id: string, pk: number, name: string, sku: string | null, images: Array<{ id: string, width: number, height: number, thumbnailUrl: string | null, url: string }> }, supplyVariants: Array<{ id: string, pk: number, name: string, variant: { id: string, pk: number, sku: string, wholesaleEnabled: boolean, wholesalePrice: { currency: string, undiscount: number, discount: number }, product: { id: string, specifics: Array<{ id: string, pk: number, name: string, shortName: string, slug: string }> } } }> }>, properties: Array<{ id: number, pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } } }>, variantImages: Array<{ id: string, thumbnail: { lg: string | null, sm: string | null } }>, similarSpecifics: Array<{ id: string, pk: number, thumbnail: { lg: string | null, sm: string | null }, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, specifics: Array<{ id: string, pk: number, slug: string, name: string, shortName: string }> }> } | null } }> } };

export type ReflectionFullInfoQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ReflectionFullInfoQuery = { reflectionDetails: { redirectUrl: string | null, reflection: { id: string, pk: number, name: string, shortName: string, videoUrl: string | null, description: string, generatedDescription: string, slug: string, skipCanonical: boolean, categories: Array<{ id: string, pk: number, name: string, slug: string, level: number }>, product: { id: string, pk: number, name: string, metaDescription: string, isInFavorites: boolean, isShippingRequired: boolean, tag: string, sku: string | null, upc: string, ean: string, isbn: string, showVariantWeight: boolean, isWeightVisible: boolean, isLengthVisible: boolean, isEanVisible: boolean, isIsbnVisible: boolean, isUpcVisible: boolean, showVariantEan: boolean, showVariantUpc: boolean, showVariantIsbn: boolean, showVariantSku: boolean, weight: number | null, length: number | null, width: number | null, height: number | null, showVariantLength: boolean, isSkuVisible: boolean, zipfileLink: string, isArchive: boolean, isInPack: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, variantsProperties: Array<{ id: number, pk: number, stockStatus: Types.OutOfStockStatusEnum, variation: number, valueName: string, attributeName: string, sortOrder: number | null }>, feedbacks: { totalCount: number }, images: Array<{ id: string, alt: string, thumbnailUrl: string | null, width: number, height: number, url: string }>, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }>, similarSpecifics: Array<{ id: string, pk: number, images: Array<{ id: string, alt: string, thumbnailUrl: string | null, url: string }>, specifics: Array<{ id: string, pk: number, name: string, shortName: string, slug: string }> }>, relatedSpecifics: Array<{ id: string, pk: number, images: Array<{ id: string, alt: string, thumbnailUrl: string | null, url: string }>, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, specifics: Array<{ id: string, pk: number, name: string, shortName: string, slug: string, categories: Array<{ id: string, pk: number, name: string, level: number }> }> }> } | null } | null } | null };


export const ProductReflectionsDocument = gql`
    query ProductReflections($first: Int!, $categories: [ID!], $end: String, $orderBy: [ProductSiteSpecificsOrder!]!, $q: String, $categoriesSlug: String, $productCollectionsSlug: String, $sale: [ID!], $withSale: Boolean, $promoCode: [Int!], $attributeData: String, $idIn: [ID!], $isWholesale: Boolean, $includeVariants: Boolean = false, $cartType: CartTypeEnum!, $isSupply: Boolean, $cartToken: String, $productIsMainRelated: Boolean, $withSimilar: Boolean = false) {
  specifics(
    first: $first
    after: $end
    filters: {categories: {id: {inList: $categories}, slug: {exact: $categoriesSlug}}, q: $q, product: {collections: {slug: {exact: $productCollectionsSlug}}, variants: {sales: {id: {inList: $sale}}}, hasWholesaleVariants: $isWholesale, isMainRelated: $productIsMainRelated}, withSale: $withSale, promoCode: $promoCode, attributeData: $attributeData, id: {inList: $idIn}, cartToken: $cartToken}
    ordering: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        categories {
          id
          pk
          name
          level
          slug
        }
        ...ReflectionInfoFragment
        product {
          ...ProductBaseInfoFragment
          thumbnail {
            lg(method: CROP_WEBP)
            sm(size: "300x0", method: CROP_WEBP)
          }
          priceRange {
            ...ProductPriceRangeFragment
          }
          wholesaleVariantsCount
          attrs @include(if: $includeVariants)
          variants(
            filters: {isSupply: {exact: $isSupply}, isWholesale: {exact: $isWholesale}}
          ) @include(if: $includeVariants) {
            ...ProductVariantDetailsFragment
            stockQuantity
            stockStatus
            outOfStockStatus
            cartQuantity(cartType: $cartType)
            cartLines(cartType: $cartType)
            thumbnailUrl(method: CROP_WEBP)
            wholesalePrice {
              currency
              undiscount
              discount
            }
            isSupply
            itemData
            supplyProducts(filters: {isWholesale: $isWholesale}) {
              ...SupplyProductFragment
            }
          }
          variantImages {
            id
            thumbnail {
              lg
              sm(size: "300x0")
            }
          }
          similarSpecifics: related @include(if: $withSimilar) {
            id
            pk
            thumbnail {
              lg
              sm(size: "300x0")
            }
            priceRange {
              ...ProductPriceRangeFragment
            }
            specifics(filters: {siteSpecifics: true}) {
              id
              pk
              slug
              name
              shortName
            }
          }
        }
      }
    }
  }
}
    ${ReflectionInfoFragmentDoc}
${ProductBaseInfoFragmentDoc}
${ProductPriceRangeFragmentDoc}
${ProductVariantDetailsFragmentDoc}
${SupplyProductFragmentDoc}`;

/**
 * __useProductReflectionsQuery__
 *
 * To run a query within a React component, call `useProductReflectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductReflectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductReflectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      categories: // value for 'categories'
 *      end: // value for 'end'
 *      orderBy: // value for 'orderBy'
 *      q: // value for 'q'
 *      categoriesSlug: // value for 'categoriesSlug'
 *      productCollectionsSlug: // value for 'productCollectionsSlug'
 *      sale: // value for 'sale'
 *      withSale: // value for 'withSale'
 *      promoCode: // value for 'promoCode'
 *      attributeData: // value for 'attributeData'
 *      idIn: // value for 'idIn'
 *      isWholesale: // value for 'isWholesale'
 *      includeVariants: // value for 'includeVariants'
 *      cartType: // value for 'cartType'
 *      isSupply: // value for 'isSupply'
 *      cartToken: // value for 'cartToken'
 *      productIsMainRelated: // value for 'productIsMainRelated'
 *      withSimilar: // value for 'withSimilar'
 *   },
 * });
 */
export function useProductReflectionsQuery(baseOptions: Apollo.QueryHookOptions<ProductReflectionsQuery, ProductReflectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductReflectionsQuery, ProductReflectionsQueryVariables>(ProductReflectionsDocument, options);
      }
export function useProductReflectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductReflectionsQuery, ProductReflectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductReflectionsQuery, ProductReflectionsQueryVariables>(ProductReflectionsDocument, options);
        }
export type ProductReflectionsQueryHookResult = ReturnType<typeof useProductReflectionsQuery>;
export type ProductReflectionsLazyQueryHookResult = ReturnType<typeof useProductReflectionsLazyQuery>;
export type ProductReflectionsQueryResult = Apollo.QueryResult<ProductReflectionsQuery, ProductReflectionsQueryVariables>;
export function refetchProductReflectionsQuery(variables: ProductReflectionsQueryVariables) {
      return { query: ProductReflectionsDocument, variables: variables }
    }
export const ReflectionFullInfoDocument = gql`
    query ReflectionFullInfo($id: ID!) {
  reflectionDetails(id: $id) {
    redirectUrl
    reflection {
      id
      pk
      name
      shortName
      videoUrl
      description
      generatedDescription
      slug
      skipCanonical
      categories {
        id
        pk
        name
        slug
        level
      }
      product {
        id
        pk
        name
        metaDescription
        isInFavorites
        isShippingRequired
        tag
        sku
        upc
        ean
        isbn
        showVariantWeight
        isWeightVisible
        isLengthVisible
        isEanVisible
        isIsbnVisible
        isUpcVisible
        showVariantEan
        showVariantUpc
        showVariantIsbn
        showVariantSku
        weight
        length
        width
        height
        showVariantLength
        isSkuVisible
        zipfileLink
        isArchive
        isInPack
        isOutOfStock
        manufacturer {
          id
          name
        }
        variantsProperties {
          id
          pk
          stockStatus
          variation
          valueName
          attributeName
          sortOrder
        }
        feedbacks {
          totalCount
        }
        images {
          id
          alt
          url: image
          thumbnailUrl(size: "1000x0", method: CROP_WEBP)
          width
          height
        }
        priceRange {
          ...ProductPriceRangeFragment
        }
        rewardPrograms {
          ...RewardProgramFragment
        }
        similarSpecifics: related {
          id
          pk
          images {
            id
            alt
            url: image
            thumbnailUrl(size: "100x0", method: CROP)
          }
          specifics(filters: {siteSpecifics: true}) {
            id
            pk
            name
            shortName
            slug
          }
        }
        relatedSpecifics: relatedProducts {
          id
          pk
          images {
            id
            alt
            url: image
            thumbnailUrl(size: "100x0", method: CROP)
          }
          priceRange {
            ...ProductPriceRangeFragment
          }
          specifics(filters: {siteSpecifics: true}) {
            id
            pk
            name
            shortName
            slug
            categories {
              id
              pk
              name
              level
            }
          }
        }
      }
    }
  }
}
    ${ProductPriceRangeFragmentDoc}
${RewardProgramFragmentDoc}`;

/**
 * __useReflectionFullInfoQuery__
 *
 * To run a query within a React component, call `useReflectionFullInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useReflectionFullInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReflectionFullInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReflectionFullInfoQuery(baseOptions: Apollo.QueryHookOptions<ReflectionFullInfoQuery, ReflectionFullInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReflectionFullInfoQuery, ReflectionFullInfoQueryVariables>(ReflectionFullInfoDocument, options);
      }
export function useReflectionFullInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReflectionFullInfoQuery, ReflectionFullInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReflectionFullInfoQuery, ReflectionFullInfoQueryVariables>(ReflectionFullInfoDocument, options);
        }
export type ReflectionFullInfoQueryHookResult = ReturnType<typeof useReflectionFullInfoQuery>;
export type ReflectionFullInfoLazyQueryHookResult = ReturnType<typeof useReflectionFullInfoLazyQuery>;
export type ReflectionFullInfoQueryResult = Apollo.QueryResult<ReflectionFullInfoQuery, ReflectionFullInfoQueryVariables>;
export function refetchReflectionFullInfoQuery(variables: ReflectionFullInfoQueryVariables) {
      return { query: ReflectionFullInfoDocument, variables: variables }
    }